import React from 'react';
import './FeedVerticalBlock.css';
import {RandomTime} from "../../../components/smiWidgets/RandomTime"
import { useVisibilityTracker } from "../../../utils/visibilityTracker"

const FeedVerticalItem = ({ item, objectId, itemsLength, showId, campaignId, creativeId, bidderId, bidderCid, eventtrackers }) => {
    const visibilityRef = useVisibilityTracker(
        item.id,
        objectId,
        'FeedVerticalBlock',
        itemsLength,
        showId,
        campaignId,
        creativeId,
        bidderId,
        bidderCid,
        eventtrackers,
        item
    );
    return (
        <a key={item.id} href={item.url} target="_blank" ref={visibilityRef}>
            <div className="feed-vertical-block">
                <div className="feed-vertical-img">
                    <img src={item.img.replace('100_100', '300_300')} alt={item.title}/>
                </div>
                <div className="feed-vertical-title">
                    <h2>{item.title}</h2>
                    <RandomTime/>
                </div>
            </div>
        </a>
    );
};

export const FeedVerticalBlock = ({items, objectId, showId}) => {
    return (
        <div className="feed-vertical-grid">
            {items.map(item => (
                <FeedVerticalItem
                    key={item.id}
                    item={item}
                    objectId={objectId}
                    itemsLength={items.length}
                    showId={showId}
                    campaignId={item.cid}
                    creativeId={item.crid}
                    bidderId={item.bidder_id}
                    bidderCid={item.bidder_cid}
                    eventtrackers={item.eventtrackers}
                />
            ))}
        </div>
    );
};
